import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule, TooltipModule } from 'ngx-bootstrap';
import { AddParticipantModalComponent } from './add-participant-modal.component';
import { InviteUserToMeetingModule } from '../invite-user-to-meeting/invite-user-to-meeting.module';

@NgModule({
  declarations: [
    AddParticipantModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InviteUserToMeetingModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot()
  ],
  exports: [
    AddParticipantModalComponent
  ],
  entryComponents: [
    AddParticipantModalComponent
  ]
})
export class AddParticipantModalModule { }
